import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=ff2517a4&scoped=true&lang=pug&"
import script from "./AppFooter.vue?vue&type=script&lang=ts&"
export * from "./AppFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=ff2517a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2517a4",
  null
  
)

component.options.__file = "AppFooter.vue"
export default component.exports